var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Box, Flex, FormControl, FormLabel, Input, FormHelperText, Checkbox, Button } from "@chakra-ui/react";
import { Observer, observer } from "mobx-react";
import React from 'react';
import { ScaleLoader } from "react-spinners";
import { StoreContext } from "../uistore/Rootstore";
import { BaseDialog } from "./BaseDialog";
import { SelectMemberDialog } from "./SelectMemberDialog";
import { Select as ChakreSelect } from "chakra-react-select";
import { DatasheetTemplate } from "../uistore/TemplateStore";
import { testIsMobile } from "@@/Util";
let DatasheetDialog = class DatasheetDialog extends React.Component {
    constructor(props) {
        super(props);
        this.inputRef = React.createRef();
        this.state = {
            id: []
        };
    }
    dialogMobileBody() {
        const rstore = this.context;
        const keys = Object.keys(DatasheetTemplate);
        const values = Object.values(DatasheetTemplate);
        const opts = [];
        for (let i = 0; i < keys.length; i++) {
            opts.push({ label: values[i], value: keys[i] });
        }
        return React.createElement(Box, { w: '100%', minH: '350px', h: '350px' },
            React.createElement(Box, { w: '100%' },
                React.createElement(FormControl, { w: '40%' },
                    React.createElement(FormLabel, { htmlFor: 'tabname' }, "Name"),
                    React.createElement(Input, { value: rstore.datasheetDialogState.name, onChange: (e) => rstore.datasheetDialogState.setName(e.currentTarget.value), id: 'tabname' }),
                    React.createElement(FormHelperText, null, "This is the name of the datasheet")),
                React.createElement(Box, null,
                    React.createElement(Viewers, null))),
            !rstore.datasheetDialogState.editmode && React.createElement(Box, { ml: testIsMobile() ? '0px' : '100px', w: testIsMobile() ? '200px' : '400px', mt: '5px' },
                React.createElement(ChakreSelect, { selectedOptionStyle: "check", options: opts, isSearchable: true, maxMenuHeight: testIsMobile() ? 100 : 200, value: opts.filter((lt) => {
                        if (rstore.datasheetDialogState.templateid === lt.value) {
                            return true;
                        }
                        return false;
                    }).map((lt) => lt), onChange: (e) => {
                        rstore.datasheetDialogState.setTemplateid(e.value);
                    }, placeholder: 'Select Template' })),
            React.createElement(Flex, { mt: '10px', w: '100%', justify: 'center', align: 'center' }, rstore.datasheetDialogState.saving && React.createElement(ScaleLoader, { color: 'green' })));
    }
    dialogBody() {
        if (testIsMobile()) {
            return this.dialogMobileBody();
        }
        const rstore = this.context;
        const keys = Object.keys(DatasheetTemplate);
        const values = Object.values(DatasheetTemplate);
        const opts = [];
        for (let i = 0; i < keys.length; i++) {
            opts.push({ label: values[i], value: keys[i] });
        }
        return React.createElement(Box, { w: '100%', minH: '350px', h: '350px' },
            React.createElement(Flex, { w: '100%', align: 'flex-start', justify: 'center' },
                React.createElement(FormControl, { w: '40%' },
                    React.createElement(FormLabel, { htmlFor: 'tabname' }, "Name"),
                    React.createElement(Input, { value: rstore.datasheetDialogState.name, onChange: (e) => rstore.datasheetDialogState.setName(e.currentTarget.value), id: 'tabname' }),
                    React.createElement(FormHelperText, null, "This is the name of the datasheet")),
                React.createElement(Box, { ml: '20px' },
                    React.createElement(Viewers, null))),
            !rstore.datasheetDialogState.editmode && React.createElement(Box, { ml: testIsMobile() ? '0px' : '100px', w: testIsMobile() ? '200px' : '400px', mt: '5px' },
                React.createElement(ChakreSelect, { selectedOptionStyle: "check", options: opts, isSearchable: true, maxMenuHeight: testIsMobile() ? 100 : 200, value: opts.filter((lt) => {
                        if (rstore.datasheetDialogState.templateid === lt.value) {
                            return true;
                        }
                        return false;
                    }).map((lt) => lt), onChange: (e) => {
                        rstore.datasheetDialogState.setTemplateid(e.value);
                    }, placeholder: 'Select Template' })),
            React.createElement(Flex, { mt: '10px', w: '100%', justify: 'center', align: 'center' }, rstore.datasheetDialogState.saving && React.createElement(ScaleLoader, { color: 'green' })));
    }
    render() {
        const rstore = this.context;
        return React.createElement(React.Fragment, null,
            React.createElement(SelectMemberDialog, { state: rstore.datasheetDialogState.smstate }),
            React.createElement(BaseDialog, { body: this.dialogBody(), state: rstore.datasheetDialogState.dialog }));
    }
};
DatasheetDialog.contextType = StoreContext;
DatasheetDialog = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], DatasheetDialog);
export { DatasheetDialog };
let Viewers = class Viewers extends React.Component {
    render() {
        const rstore = this.context;
        return React.createElement(Flex, null,
            React.createElement(Flex, { mt: testIsMobile() ? undefined : 30, alignItems: 'center' },
                React.createElement(Box, { ml: testIsMobile() ? undefined : '20px' },
                    React.createElement(Observer, null, () => React.createElement(Checkbox, { defaultChecked: rstore.datasheetDialogState.vieweabletoeveryone, onChange: (e) => rstore.datasheetDialogState.setViewableToEveryone(e.currentTarget.checked) }, "Visible to Everyone"))),
                React.createElement(Button, { ml: '10px', disabled: rstore.datasheetDialogState.vieweabletoeveryone, onClick: () => {
                        rstore.datasheetDialogState.smstate.setLetrMembers(rstore.projectStore.memberDetail);
                        rstore.datasheetDialogState.smstate.setLetrLinks(rstore.projectStore.letrlinks.map((link) => (Object.assign(Object.assign({}, link), { id: "freesoul-" + link.id }))));
                        rstore.datasheetDialogState.smstate.basestate.setOpen(true);
                    }, variant: 'solid' }, "Viewers"),
                rstore.datasheetDialogState.smstate.selectedcontacts.size > 0 && React.createElement(Button, { onClick: () => {
                        rstore.datasheetDialogState.smstate.setLetrMembers(rstore.projectStore.memberDetail);
                        rstore.datasheetDialogState.smstate.setLetrLinks(rstore.projectStore.letrlinks.map((link) => (Object.assign(Object.assign({}, link), { id: "freesoul-" + link.id }))));
                        rstore.datasheetDialogState.smstate.basestate.setOpen(true);
                    }, style: { marginLeft: 20 }, variant: 'solid' }, rstore.datasheetDialogState.smstate.selectedcontacts.size)));
    }
};
Viewers.contextType = StoreContext;
Viewers = __decorate([
    observer
], Viewers);
export { Viewers };
